// This file was generated by the Zuplo CLI migrate-dev-portal command.
// It is used to configure the Zuplo dev portal.
// You can edit this file to customize the dev portal.
// For more information, see https://zuplo.com/docs/dev-portal/zudoku/configuration/overview
import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  basePath: "/docs",
  theme: {
    registryUrl: "https://tweakcn.com/r/themes/cosmic-night.json",
    // dark: {
    //   background: "#030620",
    //   card: "#261833",
    //   muted: "#663399",
    // }
  },
  site: {
    title: "ONSIM Dev Portal",
    logo: {
      src: {
        light: "https://my.onsim.uk/assets/zuplo/onsim-zuplo-light.svg",
        dark: "https://my.onsim.uk/assets/zuplo/onsim-zuplo-dark.svg",
      },
      "width": "100px",
      alt: "ONSIM Dev Portal"
    },
  },
  metadata: {
    title: "ONSIM Dev Portal",
  },
  navigation: [
    "introduction",
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [
    { from: "/", to: "/introduction" },
    { from: "/routes/index", to: "/introduction" }  
  ],
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "/api",
    },
  ],
};
export default config;
